import services from '../../services/admins.js';
import RoleServices from '../../services/roles.js';
import Admin from '../../model/admin.js';

export const state = {
    admins: [],
    admin: {},
    roles: [],
    resetPassword: false,
}

export const mutations = {
    setAdmin(state, admin) {
        state.admin = admin
    },
    setAdmins(state, admins) {
        state.admins = admins
    },
    addAdmin(state, admin) {
        state.admins.push(admin)
    },
    setRoles(state, roles){
        state.roles = roles
    },
    setResetPassword(state, resetPassword){
        state.resetPassword = resetPassword
    }
}

export const getters = {
    getAdmin(state) {
        return new Admin(
            state.admin.id,
            state.admin.name,
            state.admin.description,
            state.admin.username,
            state.admin.permissions.map((x)=>{return x.id}),
            Number(state.admin.active)
        )
    },
    getAdmins(state) {
        return state.admins
    },
    getRoles(state){
        return state.roles; 
    }
}

export const actions = {
    get({commit}, id){
        return services.get(id)
        .then((response)=>{
            commit('setAdmin', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return services.getAll(data)
        .then((response)=>{
            commit('setAdmins', response.data.data)
            return response
        })
    },
    add({commit}, admin){
        return services.add(admin)
        .then((response)=>{
            commit('addAdmin', response.data.data)
            return response
        })
    },
    edit({state}, {id, admin}){
        return services.edit(id, admin)
        .then((response)=>{
            state.admins[state.admins.findIndex((x)=>x.id == id)] = response.data
            return response
        })
    },
    delete({state, commit}, id){
        return services.delete(id)
        .then((response)=>{
            commit('setAdmins', state.admins.filter((x)=>x.id != id))
            return response
        })
    },
    resetPassword({commit},{id, data}){
        commit('setResetPassword', true)
        return services.resetPassword(id, data)
    },
    getRoles({commit}){
        return RoleServices.getAll()
        .then((response)=>{
            commit('setRoles', response.data.data)
            return response
        })
    }
}